import{useState}from'react'
import{supabase}from'../supabase'

export default function Auth(){
const[email,setEmail]=useState('')
const[password,setPassword]=useState('')
const[isLogin,setIsLogin]=useState(true)
const[loading,setLoading]=useState(false)
const[message,setMessage]=useState('')

async function handleSubmit(){
setLoading(true)
setMessage('')
let result
if(isLogin){
result=await supabase.auth.signInWithPassword({email,password})
}else{
result=await supabase.auth.signUp({email,password})
}
if(result.error){setMessage(result.error.message)}
else if(!isLogin){setMessage('Check your email to confirm your account.')}
setLoading(false)}

return(
<div style={{minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center',background:'#f5f5f3'}}>
<div style={{background:'white',borderRadius:'16px',padding:'2rem',width:'100%',maxWidth:'400px',boxShadow:'0 4px 24px rgba(0,0,0,0.08)'}}>
<div style={{textAlign:'center',marginBottom:'2rem'}}>
<h1 style={{fontSize:'24px',fontWeight:'600',color:'#1a6b4a'}}>Greenroom</h1>
<p style={{color:'#888',fontSize:'14px',marginTop:'4px'}}>{isLogin?'Sign in to your account':'Create your account'}</p>
</div>
<input className='modal-input' type='email' placeholder='Email' value={email} onChange={e=>setEmail(e.target.value)}/>
<input className='modal-input' type='password' placeholder='Password' value={password} onChange={e=>setPassword(e.target.value)}/>
{message&&<p style={{fontSize:'13px',color:'#e53e3e',marginBottom:'12px'}}>{message}</p>}
<button onClick={handleSubmit} disabled={loading} style={{width:'100%',padding:'12px',background:'#1a6b4a',color:'white',border:'none',borderRadius:'8px',fontSize:'15px',cursor:'pointer',marginBottom:'1rem'}}>{loading?'Please wait...':(isLogin?'Sign In':'Create Account')}</button>
<p style={{textAlign:'center',fontSize:'13px',color:'#888'}}>{isLogin?'No account?':'Have an account?'}{' '}
<button onClick={()=>setIsLogin(!isLogin)} style={{background:'none',border:'none',color:'#1a6b4a',cursor:'pointer',fontSize:'13px'}}>{isLogin?'Sign up':'Sign in'}</button>
</p>
</div>
</div>
)}